export const validateTradeProposalQuantity = (quantity) => {
  const pattern = new RegExp('^[1-9][0-9]*$');
  return pattern.test(quantity);
};

export const validateTradeProposalPrice = (price) => {
  const pattern = new RegExp('^(0|[1-9][0-9]*)(\\.[0-9]{1,2})?$');
  return pattern.test(price);
};
